export default "__VITE_PUBLIC_ASSET__cdda5e01__"